import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'g10-organization-edit-notifications',
  templateUrl: './edit-notifications.component.html',
  styleUrls: ['./edit-notifications.component.css']
})
export class EditNotificationsComponent implements OnInit {

  @Input() notificationId;
  @Output() editNotificationValue = new EventEmitter();
  editNotificationForm: FormGroup;
  public enableForm:boolean=false;
  public orgID;

  public editObj={};
  /* public editObj=
  {
    
    orgID:'60866279d774d4408635033b',
    notificationID:2341,
    "title": "overspeed",
    "type": [
        "call"
    ],
    "vehicles": [
        "all"
    ],
    "timeFrom": "6:30 AM",
    "timeTo": "6:30 PM",
    "speedLimit": 200,
    "mobile": [
        "61261a01a818bfcecef14e04"
    ]

    orgID:'60866279d774d4408635033b',
    notificationID:2341,
    "title": "overspeed",
    "type": ["sms","call","email","push notifications"],
    "vehicles": ["60f66b0826aa652f099fb282","60f66b1e26aa652f099fb283"],
    "timeFrom": "3:15 AM",
    "timeTo": "4:30 AM",
    "speedLimit": 55,
    "mobile": ["61261a01a818bfcecef14e04","61261a49a818bfcecef14e05"],
    "email": ["612626c4a818bfcecef14e09","6126333da818bfcecef14e0e"]
  }; */
  public notificationObj=[];
  public getEmail:boolean=false;
  public getMobile:boolean=false;
  public getSpeed:boolean=false;
  public getGeofence:boolean=false;
  public fieldOptions={
    title:[
      {value:'overspeed',name:'overspeed'},
      {value:'geofence',name:'geofence'},
      {value:'halt',name:'halt'},
      {value:'panic',name:'panic'},
    ],
    type:[
      {value:'sms',name:'SMS'},
      {value:'call',name:'CALL'},
      {value:'email',name:'EMAIL'},
      {value:'app',name:'APP'},
    ],
    geofence:[
      {value:'619234121k2j3g41',name:'TN01CD1111'},
      {value:'6192341ask2j3g23',name:'TN02CD2222'},
      {value:'6asdfasdak2j3245',name:'TN03CD3333'},
      {value:'6agadfgafk2jvae1',name:'TN04CD4444'},
    ],
  }
  /* dropdown search filter*/
  @ViewChild('search', {static: true}) searchTextBox: ElementRef;
  filteredOptions: Observable<any[]>;
  searchTextboxControl = new FormControl();
  public data=[];
/* form input chips */
  public selectable = true;
  public removable = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  public mobiles=[];
  public emails=[];
//api obj
    public vehicleObj=[];
    public allVehicle=[];
    public allVehicleChecked:boolean=false;
// time format
    public timeFrom = { hour: 0, minute: 0, meriden: 'AM', format: 12};
    public timeTo = { hour: 0, minute: 0, meriden: 'AM', format: 12};

    public notificationConfigData={};
    
  constructor(
      public api: ApiService,
      public storage: StorageService,
      public fb: FormBuilder){
        this.orgID= this.storage.get('userInfo').orgID;
      }

  ngOnInit(): void {
    this.EditNotificationForm();
    this.getNotificationConfigData('mobile');
    this.getNotificationConfigData('email');
    this.getVehicleList();
    setTimeout(()=>{
      this.getNotificationList();
    },500)
    /* Set filter event based on value changes */
    this.filteredOptions = this.searchTextboxControl.valueChanges
    .pipe(
      startWith<string>(''),
      map(name => this._filter(name))
    );
    /* this.extraFields();
    this.setNotificationValue(); */
  }
  /* Api */
  getNotificationList() {
    const obj = {
      orgID: this.orgID
    };
    this.api.transportManagerNotificationSettingList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.notificationObj = res.data;
        this.editObj =  this.notificationObj.find((e)=> e.notificationID == this.notificationId );
        this.setNotificationValue();
        this.extraFields();
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getVehicleList(){
    let obj = {
      orgID: this.orgID,
    }
    this.api.transportManagerVehicleList(obj).then((res:any)=>{
      if (res.status == 'success') {
      this.vehicleObj=res.data;
      this.data=res.data;
      this.searchTextboxControl.patchValue('');
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  getNotificationConfigData(dataType) {
    const obj = {
      orgID: this.orgID,
      type:"list",
      notification:dataType,
    };
    this.api.transportManagerNotificationConfig(obj).then((res: any) => {
      if (res.status == 'success') {
        this.notificationConfigData[dataType]=res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  /* form load */
  EditNotificationForm() {
    this.editNotificationForm = this.fb.group({
     title:[{value:'', disabled: true},Validators.required],
     type:[{value:'', disabled: true},Validators.required],
     vehicles:[{value:'', disabled: true},Validators.required],
     timeFrom:['',Validators.required],
     timeTo:['',Validators.required],
    });
  }
  extraFields(){
    if (this.editObj['type'].includes('email')){
      this.editNotificationForm.addControl('email',this.fb.control('',[Validators.required]));
      this.editNotificationForm.controls.email.patchValue(this.editObj['email']);

      if (this.notificationConfigData['email']){
        this.fieldOptions['emails']=[];
        this.notificationConfigData['email'].filter((e)=>{
          let obj={ name:e.name, emailID:e.emailID, notificationID:e.notificationID};
          this.fieldOptions['emails'].push(obj);
        })
      }
      this.getEmail=true;
    }

    let isMobile = this.editObj['type'].find((e)=> { 
      if (e == 'sms' || 'call' || 'push notifications') return true; 
      });
      
    if (isMobile){
      this.editNotificationForm.addControl('mobile',this.fb.control('',[Validators.required]));
      this.editNotificationForm.controls.mobile.patchValue(this.editObj['mobile']);

      if (this.notificationConfigData['mobile']){
        this.fieldOptions['mobiles']=[];
        this.notificationConfigData['mobile'].filter((e)=>{
          let obj={ name:e.name, mobileNo:e.mobileNo , notificationID:e.notificationID};
          this.fieldOptions['mobiles'].push(obj);
        })
      }
      this.getMobile=true;
    }
    if(this.editObj['title']=='overspeed'){
      this.editNotificationForm.addControl('speedLimit',this.fb.control('',[Validators.required,Validators.max(200)]));
      /* this.editNotificationForm.addControl('speedAbove',this.fb.control('',[Validators.required]));
      this.editNotificationForm.addControl('speedTill',this.fb.control('',[Validators.required]));
      this.editNotificationForm.controls.speedAbove.patchValue(this.editObj.speedAbove); 
      this.editNotificationForm.controls.speedTill.patchValue(this.editObj.speedTill);  */
      this.editNotificationForm.controls.speedLimit.patchValue(this.editObj['speedLimit']);  
      this.getSpeed=true;
    }
    if(this.editObj['title']=='geofence'){
      this.editNotificationForm.addControl('geofence',this.fb.control('',[Validators.required]));
      this.editNotificationForm.controls.geofence.patchValue(this.editObj[0].geofence);
      this.getGeofence=true;
    }
    this.enableForm=true;
  }
  setNotificationValue(){
    let e=this.editObj;
    /* if (e.vehicles.includes('all')){
      this.allVehicleChecked=true;
      let vehicles=this.data.map((e)=>e.vehRegNo);
      this.editNotificationForm.controls.vehicles.patchValue(vehicles);
    }
    else  this.editNotificationForm.controls.vehicles.patchValue(e.vehicles); */
    
    this.editNotificationForm.patchValue({
      type:e['type'],
      title:e['title'],
      vehicles:e['vehicles'],
      timeFrom:e['timeFrom'],
      timeTo:e['timeTo'],
    });
    if (e['vehicles'].includes('all')) this.allVehicleChecked=true;
    this.timeFrom=this.editTimeString(e['timeFrom']);
    this.timeTo=this.editTimeString(e['timeTo']);
  }
  /* Used to filter data based on search input */
  private _filter(name: string): String[] {
    const filterValue = name.toLowerCase();
    const filteredList = this.data.filter(option => option.vehRegNo.toLowerCase().indexOf(filterValue) === 0);
    return filteredList;
    }
  
  /* Remove from selected values based on uncheck */
    selectionChange(event) {
    if (event.isUserInput && event.source.selected == false) {
      const index = this.editNotificationForm.controls.vehicles.value.indexOf(event.source.value);
      this.editNotificationForm.controls.vehicles.value.splice(index, 1);
      //this.allVehicleChecked=false;
    }
    }
  
    openedChange(e) {
    // Set search textbox value as empty while opening selectbox
    this.searchTextboxControl.patchValue('');
    console.log(e);
    // Focus to search textbox while clicking on selectbox
    if (e == true) {
      this.searchTextBox.nativeElement.focus();
    }
    }
  
  /* Clearing search textbox value */
    clearSearch(event) {
    event.stopPropagation();
    this.searchTextboxControl.patchValue('');
    }
  /* Time Change Event*/
  onChangeHour(event,field) {
    let timevalue=`${event.hour}:${event.minute} ${event.meriden}`
    this.editNotificationForm.controls[field].patchValue(timevalue);
    if(Number(event.minute)<10) event.minute=event.minute.substring(1);
    if(field=='timeFrom') this.timeFrom = event;
    if(field=='timeTo') this.timeTo = event;
  }

  editTimeString(time){                             // time '10:20 AM'
    let timeString=time;
    let splitTime=timeString.split(":");            // 10, 20 AM
    let splitMinute = splitTime[1].split(' ');      // 20, AM
    let hour=splitTime[0];
    let minute=splitMinute[0];
    let meriden=splitMinute[1];
    if(Number(minute)<10) 
      minute=minute.substring(1);
    let timeformat = { hour: hour, minute: minute, meriden: meriden, format: 12 };
    return timeformat;
  }
  /* chip add and remove */
  add(event: MatChipInputEvent,field): void {

    const value = (event.input.value || '').trim();
    // Add our fruit
    if (value) {
      if (field=='mobileField') this.mobiles.push(value);
      if (field=='emailField') this.emails.push(value);
    }
    if (field=='mobileField') this.editNotificationForm.controls.mobile.patchValue(this.mobiles);
    if (field=='emailField') this.editNotificationForm.controls.email.patchValue(this.emails);
    // Clear the input value
    if (event.input) {
      event.input.value = '';
    };
  }

  remove(value,field): void {
    let index;
    if (field=='mobileField') {
      index = this.mobiles.indexOf(value);
      if (index >= 0) this.mobiles.splice(index, 1);
    }
    if (field=='emailField') {
      index = this.emails.indexOf(value);
      if (index >= 0) this.mobiles.splice(index, 1);
    }
    if (field=='mobileField') this.editNotificationForm.controls.mobile.patchValue(this.mobiles);
    if (field=='emailField') this.editNotificationForm.controls.email.patchValue(this.emails);
  }
  /* Get Email Id from given notificationID*/

getEmailID(ID){
  let result=[];
  this.notificationConfigData['email'].filter((element)=>{
    if (element['notificationID']==ID) result.push(element);
  });
  if (result && result.length>0 ) return result[0].name;
  else return '---';
}

/* Get Mobile Number from given notificationID*/

getMobileNo(ID){
  let result=[];
  this.notificationConfigData['mobile'].filter((element)=>{
    if (element['notificationID']==ID) result.push(element);
  });
  if (result && result.length>0 ) return result[0].name;
  else return '---';
}

  onSubmit(){
    if(this.editNotificationForm.valid){
      let obj={ ...this.editNotificationForm.value };
      this.editNotificationValue.emit(obj);
    }
  }
}
